import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

export const faPendingGrowthStageIcon = faInfoCircle;
